// extracted by mini-css-extract-plugin
export default {"landing-title":"uSgOPe","landingTitle":"uSgOPe","alphaBadge":"NHFwi9"};